import React, { useEffect, useMemo } from "react";
import { MaterialReactTable } from "material-react-table";
import { useSalesInvoiceContext } from "../../../context/SalesInvoiceContext";
import { formatDate } from "../../../utils/dateFormatter";
import "../salesInvoices/salesInvoices.css";

// 🧾 الفواتير المرتجعة = فواتير البيع الملغية (is_canceled = 1)
const ReturnedInvoices = () => {
  const { invoices, loading, getSalesInvoices } = useSalesInvoiceContext();

  useEffect(() => {
    getSalesInvoices();
  }, []);

  // نعرض فقط الفواتير الملغية (المرتجعة)
  const returnedInvoices = useMemo(
    () => invoices.filter((inv) => inv.is_canceled == 1),
    [invoices]
  );

  const columns = [
    {
      accessorKey: "id",
      header: "رقم الفاتورة",
      size: 100,
      Cell: ({ row }) => `#${row.original.id}`,
    },
    {
      accessorKey: "party_name",
      header: "اسم الطرف",
      size: 200,
      Cell: ({ row }) => (
        <a
          href={`/${row.original.party_type}/${
            row.original.party_type === "supplier"
              ? row.original.supplier_id
              : row.original.customer_id
          }`}
          style={{
            color: "#3b82f6",
            textDecoration: "none",
            fontWeight: 500,
          }}
          onMouseEnter={(e) => (e.target.style.textDecoration = "underline")}
          onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
        >
          {row.original.party_name}
        </a>
      ),
    },
    {
      accessorKey: "party_phone",
      header: "هاتف الطرف",
      size: 150,
    },
    {
      accessorKey: "total_amount",
      header: "المبلغ الإجمالي",
      size: 150,
      Cell: ({ cell }) => `${parseFloat(cell.getValue()).toFixed(2)} ₪`,
    },
    {
      accessorKey: "date",
      header: "تاريخ الفاتورة",
      size: 150,
      Cell: ({ cell }) => formatDate(cell.getValue()),
    },
    {
      accessorKey: "notes",
      header: "ملاحظات",
      size: 250,
      Cell: ({ cell }) => cell.getValue() || "-",
    },
    {
      accessorKey: "is_canceled",
      header: "الحالة",
      size: 120,
      Cell: () => (
        <span
          style={{
            padding: "4px 12px",
            backgroundColor: "#fee2e2",
            color: "#dc2626",
            borderRadius: "4px",
            fontWeight: "600",
            fontSize: "13px",
          }}
        >
          مرتجعة
        </span>
      ),
    },
    {
      header: "الإجراءات",
      size: 160,
      Cell: ({ row }) => (
        <a
          href={`/sales-invoice/${row.original.id}`}
          style={{
            padding: "6px 16px",
            backgroundColor: "#10b981",
            color: "white",
            textDecoration: "none",
            borderRadius: "4px",
            fontSize: "0.875rem",
            fontWeight: 500,
            display: "inline-block",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#059669")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#10b981")}
        >
          عرض التفاصيل
        </a>
      ),
    },
  ];

  return (
    <div className="sales-invoices-page">
      <div className="page-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <h2 className="page-title" style={{ margin: 0 }}>
            الفواتير المرتجعة ({returnedInvoices.length})
          </h2>
        </div>

        {loading ? (
          <p className="loading-text">جارٍ تحميل البيانات...</p>
        ) : (
          <div className="table-wrapper">
            <MaterialReactTable
              columns={columns}
              data={returnedInvoices}
              enableColumnOrdering
              localization={{
                toolbar: { searchPlaceholder: "بحث..." },
                noRecordsToDisplay: "لا توجد فواتير مرتجعة",
              }}
              muiTableBodyRowProps={{
                sx: {
                  "&:not(:last-child)": {
                    borderBottom: "8px solid transparent",
                  },
                  "& td": { borderBottom: "1px solid #ddd" },
                },
              }}
              muiTableBodyCellProps={{
                sx: { textAlign: "right", padding: "12px 16px" },
              }}
              muiTableHeadCellProps={{
                sx: {
                  textAlign: "right",
                  padding: "12px 16px",
                  backgroundColor: "#f5f5f5",
                  fontWeight: 600,
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ReturnedInvoices;
